import { useRouter } from 'next/router';
import { GameSlug, toGameSlug } from '../config';

export default function useGameSlug(): GameSlug | null {
  const router = useRouter();
  const maybeGameSlug = router.asPath.split('/').filter(Boolean)[0];

  return toGameSlug(maybeGameSlug);
}
